<template>
  <HelpCenterViewPC v-if="isMobile === 'PC'" />
  <HelpCenterViewH5 v-if="isMobile === 'MOBILE'" />
</template>

<script setup>
import HelpCenterViewPC from './components/HelpCenterViewPC/index.vue'
import HelpCenterViewH5 from './components/HelpCenterViewH5/index.vue'

const isMobile = ref(false)
onBeforeMount(async () => {
  const userAgent = navigator.userAgent.toLowerCase()
  isMobile.value = /iphone|ipod|ipad|android|blackberry|windows phone/i.test(userAgent) ? 'MOBILE' : 'PC'
})

</script>
